module.exports = __webpack_public_path__ + "static/media/calefont11.dee65052.png";